import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Body2 } from '../components/Typo'
import { ReactComponent as DayIcon } from '../images/2026/icons/day.svg'
import { ReactComponent as FloorIcon } from '../images/2026/icons/floor.svg'
import { ReactComponent as GenreIcon } from '../images/2026/icons/genre.svg'
import { ReactComponent as TimeIcon } from '../images/2026/icons/time.svg'

type IconType = 'day' | 'time' | 'floor' | 'genre'

const icons: Record<IconType, typeof DayIcon> = {
  day: DayIcon,
  time: TimeIcon,
  floor: FloorIcon,
  genre: GenreIcon,
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const Icon = styled.div`
  display: flex;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    display: block;
  }
`

type Props = {
  icon: IconType
  children: ReactNode
}

export const ShowMetaItem: FC<Props> = ({ icon, children }) => {
  const IconComponent = icons[icon]

  return (
    <Container>
      <Icon>
        <IconComponent />
      </Icon>
      <Body2>{children}</Body2>
    </Container>
  )
}
